import type { ProcessTimerTranslations } from './processTimer.translation.pl.ts';

export const processTimerTranslations: ProcessTimerTranslations = {
  calculating: 'Calculating...',
  heartBeatError:
    'There was a connection error. Your results have been saved. The page will refresh in a moment.',
};
